import {
  IconAccountCircle,
  IconExpandMore,
  IconFavorite,
  IconHome,
  IconLocalOffer,
  IconMenu,
  IconSearch,
  IconShoppingBasket,
} from "@tvg/fuse/icon/all";
import React from "react";

export const AccountIcon: React.FC = IconAccountCircle;
export const BasketIcon: React.FC = IconShoppingBasket;
export const HomeIcon: React.FC = IconHome;
export const MyOffersIcon: React.FC = IconLocalOffer;
export const MenuIcon: React.FC = IconMenu;
export const SavedIcon: React.FC = IconFavorite;
export const SearchIcon: React.FC = IconSearch;
export const ExpandMoreIcon: React.FC = IconExpandMore;
